import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/pages/Dashboard";
import CreateStudio from "@/pages/CreateStudio";
import CommandCenter from "@/pages/CommandCenter";

function App() {
  return (
    <div className="App min-h-screen bg-[#0F1117] text-[#F8FAFC]">
      <div className="grain" />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Dashboard />} />
          <Route path="/create" element={<CreateStudio />} />
          <Route path="/project/:id" element={<CommandCenter />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" offset={80} theme="dark" richColors />
    </div>
  );
}

export default App;
